import { render, staticRenderFns } from "./PersonalEdit.vue?vue&type=template&id=51868bee"
import script from "./PersonalEdit.vue?vue&type=script&lang=js"
export * from "./PersonalEdit.vue?vue&type=script&lang=js"
import style0 from "./PersonalEdit.vue?vue&type=style&index=0&id=51868bee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports